<template>
  <b-row class="container-custom">
    <div v-if="isLoading" class="m-3 d-flex justify-content-center w-100">
      <b-spinner variant="primary" label="Text Centered"></b-spinner>
    </div>
    <b-row v-for="option in options" :key="option.id">
      <span :class="`custom-badge px-3 py-2 ${styleBadge(option.id)} mr-3`" @click="handleChange(option.id)">
        {{ $t(option.nome) }}
      </span>
    </b-row>
  </b-row>
</template>
<script>
export default {
  props: ['data', 'defaultValue', 'isMulti'],

  data() {
    return {
      selected: null,
      options: [],
      isLoading: false
    };
  },
  watch: {
    defaultValue(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.options.length > 0) {
          this.handleChange(this.defaultValue);
        }
      }
    }
  },

  created() {
    this.options = this.data.filter((opt) => (Object.hasOwn(opt, 'show') ? opt.show : true));
    this.handleChange(this.defaultValue || this.options[0].id);
  },
  methods: {
    handleChange(option) {
      if (option) {
        this.selected = this.isMulti ? this.setMultiValue(option) : this.setValue(option);
        this.$emit('input', !this.isMulti ? this.selected.id : this.selected);
      } else {
        this.selected = null;
        this.$emit('input', this.selected);
      }
    },

    setValue(option) {
      if (option) {
        this.selected = this.options.find((opt) => opt.id == option);
        return this.selected.id;
      } else {
        this.selected = null;
        return this.selected;
      }
    },
    setMultiValue(option) {
      if (option) {
        if (this.selected) {
          const hasOption = this.selected.find((opt) => opt.id == option) ? true : false;
          this.selected = hasOption
            ? this.selected.length > 1
              ? this.selected.filter((opt) => opt.id !== option)
              : [this.options.find((opt) => opt.id == option)]
            : [...this.selected, this.options.find((opt) => opt.id == option)];
        } else {
          this.selected = [this.options.find((opt) => opt.id == option)];
        }
        return this.selected;
      } else {
        this.selected = null;
        return this.selected;
      }
    },
    styleBadge(id) {
      return !this.isMulti
        ? this.selected && this.selected.id == id
          ? 'badge badge-primary'
          : 'badge badge-secondary'
        : Array.isArray(this.selected) && this.selected.find((opt) => opt.id == id)
        ? 'badge badge-primary'
        : 'badge badge-secondary';
    }
  }
};
</script>

<style lang="scss" scoped>
.card-header {
  padding: 0.75rem 0 !important;
}
.container-custom {
  flex-wrap: nowrap;
  overflow-x: auto;
  max-width: 1000px;
  gap: 15px;
  padding-left: 25px;
}
.custom-badge {
  cursor: pointer;
  border-radius: 5px;
}

/* width */
::-webkit-scrollbar {
  height: 5px;
  margin-top: 5px;
}
/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgb(212, 212, 212);
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(223, 223, 223);
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(184, 184, 184);
}
</style>
